import Head from 'next/head'
import dynamic from 'next/dynamic'
import Header from '../components/header'
const Footer = dynamic(() => import('../components/footer'))

import AlphaList from '../components/taxonomies/alphafilter/alphalist'
const MiniCart = dynamic(() => import('../components/cart/minicart'))
import parse from 'html-react-parser'

function Category({ list, menu, config, page }) {

  return (
    <>
      <Head>
        <title>Categories</title>
      </Head>
      <div className="wrapper h-full flex flex-col">
        <Header menu={menu} config={config}></Header>
        <AlphaList list={list} type="category" title="Category"></AlphaList>
        {(page && page.description) ? 
            <>
            <div className="py-8 lg:py-16">
                <div className="container mx-auto category-description">
                    <div className="block mx-auto w-full px-5 lg:px-0">
                    {(parse(page.description))}
                    </div>
                </div>
            </div>
            </> : ('')}
            
        <Footer menu={menu} config={config}></Footer>
      </div>
      <MiniCart></MiniCart>
    </>
  )
}


// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps(context) {
  const config_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/configs')
  const config_data = await config_res.json()
  const config = config_data.data

  const menu_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/menu')
  const menu = await menu_res.json()

  const taxres = await fetch(process.env.NEXT_PUBLIC_API_URL + '/taxonomies/category')
  const taxresponse = await taxres.json()
  const list = taxresponse.data

  const res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/landingpage/categories')
  const response = await res.json()
  const page = response.data

  return {
    props: {
      config: config,
      menu: menu,
      list: list,
      page: page,
    },
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    // - At most once every 10 seconds
    revalidate: 600, // In seconds

  }
}



export default Category